import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, withKeys as _withKeys, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withModifiers as _withModifiers, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "py-4 sm:py-8 sm:p-8" }
const _hoisted_2 = { class: "mb-10 flex items-center justify-between" }
const _hoisted_3 = { class: "mb-6 flex items-center justify-between flex-wrap gap-4" }
const _hoisted_4 = { class: "flex flex-wrap items-center gap-4" }
const _hoisted_5 = { class: "relative" }
const _hoisted_6 = { class: "flex flex-wrap gap-1" }
const _hoisted_7 = {
  key: 0,
  class: "text-zinc-500"
}
const _hoisted_8 = {
  key: 0,
  class: "space-y-4 md:hidden text-left"
}
const _hoisted_9 = { class: "flex items-center gap-2" }
const _hoisted_10 = { class: "flex flex-col" }
const _hoisted_11 = { class: "flex items-center gap-2" }
const _hoisted_12 = { class: "text-white font-bold text-lg" }
const _hoisted_13 = { class: "flex flex-col items-end gap-2" }
const _hoisted_14 = { class: "flex items-center gap-1" }
const _hoisted_15 = ["onClick"]
const _hoisted_16 = ["onClick"]
const _hoisted_17 = { class: "flex flex-wrap gap-1" }
const _hoisted_18 = {
  key: 0,
  class: "text-zinc-500"
}
const _hoisted_19 = {
  key: 1,
  class: "text-center py-12 text-zinc-500"
}
const _hoisted_20 = { class: "grid grid-cols-1 md:grid-cols-2 gap-6 py-4" }
const _hoisted_21 = { class: "space-y-4" }
const _hoisted_22 = { class: "space-y-1" }
const _hoisted_23 = {
  key: 0,
  class: "text-xs text-red-500"
}
const _hoisted_24 = { class: "space-y-1" }
const _hoisted_25 = {
  key: 0,
  class: "text-xs text-red-500"
}
const _hoisted_26 = { class: "space-y-2" }
const _hoisted_27 = { class: "grid grid-cols-2 gap-4" }
const _hoisted_28 = { class: "space-y-1" }
const _hoisted_29 = {
  key: 0,
  class: "text-xs text-red-500"
}
const _hoisted_30 = { class: "space-y-2" }
const _hoisted_31 = { class: "flex gap-2 flex-wrap items-center px-3" }
const _hoisted_32 = { class: "grid grid-cols-2 gap-4" }
const _hoisted_33 = { class: "space-y-1" }
const _hoisted_34 = {
  key: 0,
  class: "text-xs text-red-500"
}
const _hoisted_35 = { class: "space-y-1" }
const _hoisted_36 = {
  key: 0,
  class: "text-xs text-red-500"
}
const _hoisted_37 = { class: "space-y-6" }
const _hoisted_38 = { class: "space-y-2" }
const _hoisted_39 = { class: "space-y-2" }

import { ref, onMounted, computed, watch } from 'vue'
import {
  MagnifyingGlassIcon,
  CreditCardIcon,
  PencilIcon,
  TrashIcon,
} from '@heroicons/vue/24/outline'
import MobileCard from '@/components/ui/mobile-card/MobileCard.vue'
import MobileDataLabel from '@/components/ui/mobile-card/MobileDataLabel.vue'
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogScrollContent,
  DialogTitle,
} from '@/components/ui/dialog'
import { Button } from '@/components/ui/button'
import { Input } from '@/components/ui/input'
import { Label } from '@/components/ui/label'
import { Textarea } from '@/components/ui/textarea'
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select'
import RegisterButton from '@/components/ui/register-button/RegisterButton.vue'
import Table from '@/components/ui/table/Table.vue'
import TableHeader from '@/components/ui/table/TableHeader.vue'
import TableRow from '@/components/ui/table/TableRow.vue'
import TableHead from '@/components/ui/table/TableHead.vue'
import TableBody from '@/components/ui/table/TableBody.vue'
import TableFallback from '@/components/ui/table/TableFallback.vue'
import TableCell from '@/components/ui/table/TableCell.vue'
import TableContainer from '@/components/ui/table/TableContainer.vue'
import TableRowSkeleton from '@/components/ui/table/TableRowSkeleton.vue'
import { useOrderBump, CreateOrderBumpDTO, UpdateOrderBumpDTO } from '@/composables/useOrderBump'
import { usePaymentPlan } from '@/composables/usePaymentPlan'
import { useMedia } from '@/composables/useMedia'
import { OrderBump } from '@/interfaces/OrderBump'
import { PaymentPlan } from '@/interfaces/PaymentPlan'
import { useToast } from '@/components/ui/toast'
import DeleteConfirmationDialog from '@/components/ui/delete-dialog/DeleteConfirmationDialog.vue'
import { Loader2 } from 'lucide-vue-next'
import PageTitle from '@/components/ui/page/PageTitle.vue'
import PageDescription from '@/components/ui/page/PageDescription.vue'
import AnyFileUpload from '@/components/ui/upload/AnyFileUpload.vue'
import AudioUpload from '@/components/ui/upload/AudioUpload.vue'
import RichTextarea from '@/components/ui/textarea/RichTextarea.vue'
import { Badge } from '@/components/ui/badge'
import {
  TagsInput,
  TagsInputInput,
  TagsInputItem,
  TagsInputItemDelete,
  TagsInputItemText,
} from '@/components/ui/tags-input'
import {
  ComboboxAnchor,
  ComboboxContent,
  ComboboxInput,
  ComboboxPortal,
  ComboboxRoot,
} from 'radix-vue'
import {
  CommandEmpty,
  CommandGroup,
  CommandItem,
  CommandList,
} from '@/components/ui/command'


export default /*@__PURE__*/_defineComponent({
  __name: 'ManageOrderBumpsView',
  setup(__props) {

const { getAll, create, update, destroy } = useOrderBump()
const { getAll: getAllPlans } = usePaymentPlan()
const { upload } = useMedia()
const { toast } = useToast()

const orderBumps = ref<OrderBump[] | null>(null)
const paymentPlans = ref<PaymentPlan[]>([])
const searchQuery = ref('')
const isDialogOpen = ref(false)
const isSaving = ref(false)
const editingBump = ref<OrderBump | null>(null)

// Form
const form = ref({
    name: '',
    title: '',
    deliverables: '',
    amount: '',
    paymentPlanIds: [] as number[],
    acceptButtonText: '',
    declineButtonText: '',
    mediaHasSpoiler: false
})

const paymentPlanNames = ref<string[]>([])
const searchPaymentPlan = ref('')
const isPaymentPlanComboboxOpen = ref(false)
const showErrors = ref(false)

const filteredPaymentPlans = computed(() => {
    return paymentPlans.value.filter(plan => !form.value.paymentPlanIds.includes(plan.id) && plan.name.toLowerCase().includes(searchPaymentPlan.value.toLowerCase()))
})


const mediaFile = ref<File>()
const mediaPreview = ref('')
const audioFile = ref<File>()
const audioPreview = ref('')

// Delete
const isDeleteDialogOpen = ref(false)
const isDeleting = ref(false)
const bumpToDelete = ref<OrderBump | null>(null)

const errors = computed(() => {
    const errs: any = {}
    if (!form.value.name) errs.name = 'Nome é obrigatório'
    if (!form.value.title) errs.title = 'Título é obrigatório'
    if (!form.value.amount) {
        errs.amount = 'Valor é obrigatório'
    } else if (Number(form.value.amount) < 3) {
        errs.amount = 'O valor mínimo é R$ 3,00'
    }
    if (!form.value.acceptButtonText) errs.acceptButtonText = 'Texto do botão aceitar é obrigatório'
    if (!form.value.declineButtonText) errs.declineButtonText = 'Texto do botão rejeitar é obrigatório'
    return errs
})

const isValid = computed(() => {
    return Object.keys(errors.value).length === 0
})

const fetchData = async () => {
    orderBumps.value = null
    const [bumpsData, plansData] = await Promise.all([
        getAll(),
        getAllPlans({ page: '1', perPage: '100' }) // Fetch all plans
    ])
    orderBumps.value = bumpsData
    paymentPlans.value = plansData.data
}

onMounted(() => {
    fetchData()
})

const openDialog = () => {
    editingBump.value = null
    form.value = {
        name: '',
        title: '',
        deliverables: '',
        amount: '',
        paymentPlanIds: [],
        acceptButtonText: 'Sim, eu quero!',
        declineButtonText: 'Não, obrigado',
        mediaHasSpoiler: false
    }
    paymentPlanNames.value = []
    mediaFile.value = undefined
    mediaPreview.value = ''
    audioFile.value = undefined
    audioPreview.value = ''
    isDialogOpen.value = true
    showErrors.value = false
}

const editBump = (bump: OrderBump) => {
    editingBump.value = bump
    
    // Extract payment plans
    const connectedPlans = (bump as any).paymentPlans || [];
    const planIds = connectedPlans.map((p: any) => p.id);
    const planNames = connectedPlans.map((p: any) => p.name);

    form.value = {
        name: bump.name,
        title: bump.title,
        deliverables: bump.deliverables || '',
        amount: String(bump.amount),
        paymentPlanIds: planIds,
        acceptButtonText: bump.acceptButtonText,
        declineButtonText: bump.declineButtonText,
        mediaHasSpoiler: bump.mediaHasSpoiler
    }
    paymentPlanNames.value = planNames
    mediaFile.value = undefined
    mediaPreview.value = bump.mediaUrl || ''
    audioFile.value = undefined
    audioPreview.value = bump.audioUrl || ''
    isDialogOpen.value = true
    showErrors.value = false
}

const save = async () => {
    showErrors.value = true
    if (!isValid.value) return

    isSaving.value = true
    try {
        let mediaUrl = editingBump.value?.mediaUrl
        let mediaType = editingBump.value?.mediaType
        let audioUrl = editingBump.value?.audioUrl

        if (mediaFile.value) {
            const uploaded = await upload(mediaFile.value)
            mediaUrl = uploaded.source
            mediaType = uploaded.type.toLowerCase() // Ensure consistency
        }
        
        if (audioFile.value) {
            const uploaded = await upload(audioFile.value)
            audioUrl = uploaded.source
        }

        const payload: any = {
            name: form.value.name,
            title: form.value.title,
            deliverables: form.value.deliverables,
            amount: Number(form.value.amount),
            paymentPlanIds: form.value.paymentPlanIds,
            acceptButtonText: form.value.acceptButtonText,
            declineButtonText: form.value.declineButtonText,
            mediaUrl,
            mediaType,
            audioUrl,
            mediaHasSpoiler: form.value.mediaHasSpoiler
        }

        if (editingBump.value) {
            await update(editingBump.value.id, payload)
            toast({ title: 'Order Bump atualizado!', class: 'bg-green-500 text-white' })
        } else {
            await create(payload)
            toast({ title: 'Order Bump criado!', class: 'bg-green-500 text-white' })
        }
        
        isDialogOpen.value = false
        fetchData()
    } catch (error) {
        console.error(error)
        toast({ title: 'Erro ao salvar', variant: 'destructive' })
    } finally {
        isSaving.value = false
    }
}

const confirmDelete = (bump: OrderBump) => {
    bumpToDelete.value = bump
    isDeleteDialogOpen.value = true
}

const confirmDeleteAction = async () => {
    if (!bumpToDelete.value) return
    isDeleting.value = true
    try {
        await destroy(bumpToDelete.value.id)
        toast({ title: 'Order Bump excluído!', class: 'bg-green-500 text-white' })
        fetchData()
        isDeleteDialogOpen.value = false
    } catch (error) {
        toast({ title: 'Erro ao excluir', variant: 'destructive' })
    } finally {
        isDeleting.value = false
    }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", null, [
        _createVNode(PageTitle, null, {
          default: _withCtx(() => _cache[20] || (_cache[20] = [
            _createTextVNode("Gerencie seus Order Bumps")
          ])),
          _: 1
        }),
        _createVNode(PageDescription, null, {
          default: _withCtx(() => _cache[21] || (_cache[21] = [
            _createTextVNode(" Ofereça produtos complementares no momento do checkout para aumentar seu ticket médio. ")
          ])),
          _: 1
        })
      ]),
      _createVNode(RegisterButton, { onClick: openDialog }, {
        default: _withCtx(() => _cache[22] || (_cache[22] = [
          _createTextVNode("Criar Order Bump")
        ])),
        _: 1
      })
    ]),
    _createVNode(TableContainer, null, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_3, [
          _cache[23] || (_cache[23] = _createElementVNode("h2", { class: "text-xl font-semibold text-white" }, "Order Bumps ativos", -1)),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_unref(Input), {
                modelValue: searchQuery.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchQuery).value = $event)),
                placeholder: "Buscar...",
                class: "w-[280px]",
                onKeydown: _cache[1] || (_cache[1] = _withKeys(($event: any) => (fetchData()), ["enter"]))
              }, {
                prefix: _withCtx(() => [
                  _createVNode(_unref(MagnifyingGlassIcon), { class: "h-4 w-4 text-zinc-400" })
                ]),
                _: 1
              }, 8, ["modelValue"])
            ])
          ])
        ]),
        _createVNode(Table, { class: "hidden md:block" }, {
          default: _withCtx(() => [
            _createVNode(TableHeader, null, {
              default: _withCtx(() => [
                _createVNode(TableRow, null, {
                  default: _withCtx(() => [
                    _createVNode(TableHead, null, {
                      default: _withCtx(() => _cache[24] || (_cache[24] = [
                        _createTextVNode("Nome")
                      ])),
                      _: 1
                    }),
                    _createVNode(TableHead, null, {
                      default: _withCtx(() => _cache[25] || (_cache[25] = [
                        _createTextVNode("Título (Texto)")
                      ])),
                      _: 1
                    }),
                    _createVNode(TableHead, null, {
                      default: _withCtx(() => _cache[26] || (_cache[26] = [
                        _createTextVNode("Valor")
                      ])),
                      _: 1
                    }),
                    _createVNode(TableHead, null, {
                      default: _withCtx(() => _cache[27] || (_cache[27] = [
                        _createTextVNode("Plano Gatilho")
                      ])),
                      _: 1
                    }),
                    _createVNode(TableHead, { class: "text-right" }, {
                      default: _withCtx(() => _cache[28] || (_cache[28] = [
                        _createTextVNode("Ações")
                      ])),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(TableBody, null, {
              default: _withCtx(() => [
                (orderBumps.value)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      (orderBumps.value.length === 0)
                        ? (_openBlock(), _createBlock(TableFallback, {
                            key: 0,
                            colspan: 5,
                            icon: _unref(CreditCardIcon),
                            title: "Nenhum Order Bump encontrado",
                            description: "Clique em 'Criar Order Bump' para começar"
                          }, null, 8, ["icon"]))
                        : _createCommentVNode("", true),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(orderBumps.value, (bump) => {
                        return (_openBlock(), _createBlock(TableRow, {
                          key: bump.id
                        }, {
                          default: _withCtx(() => [
                            _createVNode(TableCell, { class: "font-medium text-white" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(bump.name), 1)
                              ]),
                              _: 2
                            }, 1024),
                            _createVNode(TableCell, { class: "text-zinc-300" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(bump.title), 1)
                              ]),
                              _: 2
                            }, 1024),
                            _createVNode(TableCell, { class: "text-zinc-300" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(bump.amount.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })), 1)
                              ]),
                              _: 2
                            }, 1024),
                            _createVNode(TableCell, { class: "text-zinc-300" }, {
                              default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_6, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(bump.paymentPlans, (plan) => {
                                    return (_openBlock(), _createBlock(_unref(Badge), {
                                      key: plan.id
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(plan.name), 1)
                                      ]),
                                      _: 2
                                    }, 1024))
                                  }), 128)),
                                  (!bump.paymentPlans?.length)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_7, "-"))
                                    : _createCommentVNode("", true)
                                ])
                              ]),
                              _: 2
                            }, 1024),
                            _createVNode(TableCell, { class: "text-right" }, {
                              default: _withCtx(() => [
                                _createVNode(_unref(Button), {
                                  variant: "ghost",
                                  size: "icon",
                                  onClick: ($event: any) => (editBump(bump))
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_unref(PencilIcon), { class: "h-4 w-4" })
                                  ]),
                                  _: 2
                                }, 1032, ["onClick"]),
                                _createVNode(_unref(Button), {
                                  variant: "ghost",
                                  size: "icon",
                                  class: "hover:text-red-400",
                                  onClick: ($event: any) => (confirmDelete(bump))
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_unref(TrashIcon), { class: "h-4 w-4" })
                                  ]),
                                  _: 2
                                }, 1032, ["onClick"])
                              ]),
                              _: 2
                            }, 1024)
                          ]),
                          _: 2
                        }, 1024))
                      }), 128))
                    ], 64))
                  : (_openBlock(), _createBlock(TableRowSkeleton, {
                      key: 1,
                      columns: 5
                    }))
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        (orderBumps.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
              (orderBumps.value.length > 0)
                ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(orderBumps.value, (bump) => {
                    return (_openBlock(), _createBlock(MobileCard, {
                      key: bump.id
                    }, {
                      header: _withCtx(() => [
                        _createElementVNode("div", _hoisted_9, [
                          _createElementVNode("div", _hoisted_10, [
                            _cache[29] || (_cache[29] = _createElementVNode("span", { class: "text-[10px] uppercase font-bold text-zinc-500 tracking-wider" }, "Order Bump", -1)),
                            _createElementVNode("div", _hoisted_11, [
                              _createElementVNode("span", _hoisted_12, _toDisplayString(bump.name), 1)
                            ])
                          ])
                        ])
                      ]),
                      actions: _withCtx(() => [
                        _createElementVNode("div", _hoisted_13, [
                          _createElementVNode("div", _hoisted_14, [
                            _createElementVNode("button", {
                              onClick: ($event: any) => (editBump(bump)),
                              class: "text-zinc-400 hover:text-white p-1"
                            }, [
                              _createVNode(_unref(PencilIcon), { class: "size-5" })
                            ], 8, _hoisted_15),
                            _createElementVNode("button", {
                              onClick: ($event: any) => (confirmDelete(bump)),
                              class: "text-zinc-400 hover:text-red-400 p-1"
                            }, [
                              _createVNode(_unref(TrashIcon), { class: "size-5" })
                            ], 8, _hoisted_16)
                          ])
                        ])
                      ]),
                      content: _withCtx(() => [
                        _createVNode(MobileDataLabel, { label: "Título" }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(bump.title), 1)
                          ]),
                          _: 2
                        }, 1024),
                        _createVNode(MobileDataLabel, { label: "Valor" }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(bump.amount.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })), 1)
                          ]),
                          _: 2
                        }, 1024),
                        _createVNode(MobileDataLabel, { label: "Planos Gatilho" }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_17, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(bump.paymentPlans, (plan) => {
                                return (_openBlock(), _createBlock(_unref(Badge), {
                                  key: plan.id
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(plan.name), 1)
                                  ]),
                                  _: 2
                                }, 1024))
                              }), 128)),
                              (!bump.paymentPlans?.length)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_18, "-"))
                                : _createCommentVNode("", true)
                            ])
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _: 2
                    }, 1024))
                  }), 128))
                : (_openBlock(), _createElementBlock("div", _hoisted_19, [
                    _createVNode(_unref(CreditCardIcon), { class: "size-8 mx-auto mb-3 text-zinc-700" }),
                    _cache[30] || (_cache[30] = _createTextVNode(" Nenhum Order Bump encontrado "))
                  ]))
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_unref(Dialog), {
      open: isDialogOpen.value,
      "onUpdate:open": _cache[18] || (_cache[18] = ($event: any) => ((isDialogOpen).value = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(DialogScrollContent), { class: "max-w-4xl" }, {
          default: _withCtx(() => [
            _createVNode(_unref(DialogHeader), null, {
              default: _withCtx(() => [
                _createVNode(_unref(DialogTitle), null, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(editingBump.value ? 'Editar Order Bump' : 'Novo Order Bump'), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_unref(DialogDescription), null, {
                  default: _withCtx(() => _cache[31] || (_cache[31] = [
                    _createTextVNode(" Configure a oferta que aparecerá para o cliente. "),
                    _createElementVNode("br", null, null, -1),
                    _createTextVNode("Variáveis disponíveis no texto: "),
                    _createElementVNode("span", { class: "text-emerald-400" }, "{{plano}}, {{valor}}, {{valor_total}}, {{nome}}", -1)
                  ])),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createElementVNode("div", _hoisted_20, [
              _createElementVNode("div", _hoisted_21, [
                _createElementVNode("div", _hoisted_22, [
                  _createVNode(_unref(Label), null, {
                    default: _withCtx(() => _cache[32] || (_cache[32] = [
                      _createTextVNode("Nome Interno "),
                      _createElementVNode("span", { class: "text-red-500" }, "*", -1)
                    ])),
                    _: 1
                  }),
                  _createVNode(_unref(Input), {
                    modelValue: form.value.name,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((form.value.name) = $event)),
                    placeholder: "Ex: Oferta VIP"
                  }, null, 8, ["modelValue"]),
                  (showErrors.value && errors.value.name)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_23, _toDisplayString(errors.value.name), 1))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_24, [
                  _createVNode(_unref(Label), null, {
                    default: _withCtx(() => _cache[33] || (_cache[33] = [
                      _createTextVNode("Texto Explicativo (Título) "),
                      _createElementVNode("span", { class: "text-red-500" }, "*", -1)
                    ])),
                    _: 1
                  }),
                  _createVNode(RichTextarea, {
                    modelValue: form.value.title,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((form.value.title) = $event)),
                    placeholder: "Ex: Que tal levar também...",
                    rows: 3,
                    variables: [
                            { label: 'Plano', value: '{{plano}}' },
                            { label: 'Valor', value: '{{valor}}' },
                            { label: 'Valor Total', value: '{{valor_total}}' },
                            { label: 'Nome', value: '{{nome}}' }
                        ]
                  }, null, 8, ["modelValue"]),
                  (showErrors.value && errors.value.title)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_25, _toDisplayString(errors.value.title), 1))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_26, [
                  _createVNode(_unref(Label), null, {
                    default: _withCtx(() => _cache[34] || (_cache[34] = [
                      _createTextVNode("Entregáveis (Descrição)")
                    ])),
                    _: 1
                  }),
                  _createVNode(RichTextarea, {
                    modelValue: form.value.deliverables,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((form.value.deliverables) = $event)),
                    placeholder: "Ex: Acesso ao grupo VIP...",
                    rows: 3,
                    variables: [
                            { label: 'Nome', value: '{{nome}}' }
                        ]
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_27, [
                  _createElementVNode("div", _hoisted_28, [
                    _createVNode(_unref(Label), null, {
                      default: _withCtx(() => _cache[35] || (_cache[35] = [
                        _createTextVNode("Valor do Bump "),
                        _createElementVNode("span", { class: "text-red-500" }, "*", -1)
                      ])),
                      _: 1
                    }),
                    _createVNode(_unref(Input), {
                      modelValue: form.value.amount,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((form.value.amount) = $event)),
                      type: "number",
                      step: "0.01",
                      min: "3",
                      placeholder: "0.00"
                    }, null, 8, ["modelValue"]),
                    (showErrors.value && errors.value.amount)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_29, _toDisplayString(errors.value.amount), 1))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_30, [
                    _createVNode(_unref(Label), null, {
                      default: _withCtx(() => _cache[36] || (_cache[36] = [
                        _createTextVNode("Planos Gatilho "),
                        _createElementVNode("span", { class: "text-red-500" }, "*", -1)
                      ])),
                      _: 1
                    }),
                    (filteredPaymentPlans.value)
                      ? (_openBlock(), _createBlock(_unref(TagsInput), {
                          key: 0,
                          class: "px-0 gap-0 w-full",
                          "model-value": paymentPlanNames.value
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_31, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(paymentPlanNames.value, (name, index) => {
                                return (_openBlock(), _createBlock(_unref(TagsInputItem), {
                                  key: index,
                                  value: name
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_unref(TagsInputItemText)),
                                    _createVNode(_unref(TagsInputItemDelete), {
                                      onClick: ($event: any) => {form.value.paymentPlanIds?.splice(index, 1); paymentPlanNames.value.splice(index, 1)}
                                    }, null, 8, ["onClick"])
                                  ]),
                                  _: 2
                                }, 1032, ["value"]))
                              }), 128))
                            ]),
                            _createVNode(_unref(ComboboxRoot), {
                              modelValue: paymentPlanNames.value,
                              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((paymentPlanNames).value = $event)),
                              open: isPaymentPlanComboboxOpen.value,
                              "onUpdate:open": _cache[9] || (_cache[9] = ($event: any) => ((isPaymentPlanComboboxOpen).value = $event)),
                              "search-term": searchPaymentPlan.value,
                              "onUpdate:searchTerm": _cache[10] || (_cache[10] = ($event: any) => ((searchPaymentPlan).value = $event)),
                              class: "w-full"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_unref(ComboboxAnchor), { "as-child": "" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_unref(ComboboxInput), {
                                      placeholder: "Selecione os planos...",
                                      "as-child": ""
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_unref(TagsInputInput), {
                                          onFocus: _cache[6] || (_cache[6] = ($event: any) => (isPaymentPlanComboboxOpen.value = true)),
                                          class: _normalizeClass(["w-full px-3", (form.value.paymentPlanIds?.length ?? 0) > 0 ? 'mt-2' : '']),
                                          onKeydown: _cache[7] || (_cache[7] = _withKeys(_withModifiers(() => {}, ["prevent"]), ["enter"]))
                                        }, null, 8, ["class"])
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_unref(ComboboxPortal), null, {
                                  default: _withCtx(() => [
                                    _createVNode(_unref(ComboboxContent), null, {
                                      default: _withCtx(() => [
                                        _createVNode(_unref(CommandList), {
                                          position: "popper",
                                          class: "w-[--radix-popper-anchor-width] rounded-md mt-2 border bg-popover text-popover-foreground shadow-md outline-none data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 z-50"
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_unref(CommandEmpty), null, {
                                              default: _withCtx(() => _cache[37] || (_cache[37] = [
                                                _createTextVNode("Nenhum plano encontrado")
                                              ])),
                                              _: 1
                                            }),
                                            _createVNode(_unref(CommandGroup), null, {
                                              default: _withCtx(() => [
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredPaymentPlans.value, (paymentPlan) => {
                                                  return (_openBlock(), _createBlock(_unref(CommandItem), {
                                                    key: paymentPlan.id,
                                                    value: String(paymentPlan.name),
                                                    onSelect: _withModifiers((ev) => {
                                            if (typeof ev.detail.value === 'string') {
                                              searchPaymentPlan.value = ''
                                              const paymentPlan = filteredPaymentPlans.value?.find(plan => plan.name == ev.detail.value)
                                              form.value.paymentPlanIds?.push(paymentPlan!.id)
                                              paymentPlanNames.value.push(paymentPlan!.name)
                                            }
                          
                                            if (filteredPaymentPlans.value?.length === 0) {
                                              isPaymentPlanComboboxOpen.value = false
                                            }
                                          }, ["prevent"])
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _createTextVNode(_toDisplayString(paymentPlan.name), 1)
                                                    ]),
                                                    _: 2
                                                  }, 1032, ["value", "onSelect"]))
                                                }), 128))
                                              ]),
                                              _: 1
                                            })
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }, 8, ["modelValue", "open", "search-term"])
                          ]),
                          _: 1
                        }, 8, ["model-value"]))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createElementVNode("div", _hoisted_32, [
                  _createElementVNode("div", _hoisted_33, [
                    _createVNode(_unref(Label), null, {
                      default: _withCtx(() => _cache[38] || (_cache[38] = [
                        _createTextVNode("Texto Botão Aceitar "),
                        _createElementVNode("span", { class: "text-red-500" }, "*", -1)
                      ])),
                      _: 1
                    }),
                    _createVNode(_unref(Input), {
                      modelValue: form.value.acceptButtonText,
                      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((form.value.acceptButtonText) = $event)),
                      placeholder: "Sim, eu quero!"
                    }, null, 8, ["modelValue"]),
                    (showErrors.value && errors.value.acceptButtonText)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_34, _toDisplayString(errors.value.acceptButtonText), 1))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_35, [
                    _createVNode(_unref(Label), null, {
                      default: _withCtx(() => _cache[39] || (_cache[39] = [
                        _createTextVNode("Texto Botão Rejeitar "),
                        _createElementVNode("span", { class: "text-red-500" }, "*", -1)
                      ])),
                      _: 1
                    }),
                    _createVNode(_unref(Input), {
                      modelValue: form.value.declineButtonText,
                      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((form.value.declineButtonText) = $event)),
                      placeholder: "Não, obrigado"
                    }, null, 8, ["modelValue"]),
                    (showErrors.value && errors.value.declineButtonText)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_36, _toDisplayString(errors.value.declineButtonText), 1))
                      : _createCommentVNode("", true)
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_37, [
                _createElementVNode("div", _hoisted_38, [
                  _createVNode(AnyFileUpload, {
                    modelValue: mediaFile.value,
                    "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((mediaFile).value = $event)),
                    preview: mediaPreview.value,
                    "onUpdate:preview": _cache[14] || (_cache[14] = ($event: any) => ((mediaPreview).value = $event)),
                    "has-spoiler": form.value.mediaHasSpoiler,
                    "onUpdate:hasSpoiler": _cache[15] || (_cache[15] = ($event: any) => ((form.value.mediaHasSpoiler) = $event)),
                    label: "Mídia (Imagem ou Vídeo)"
                  }, null, 8, ["modelValue", "preview", "has-spoiler"])
                ]),
                _createElementVNode("div", _hoisted_39, [
                  _createVNode(AudioUpload, {
                    modelValue: audioFile.value,
                    "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((audioFile).value = $event)),
                    initialPreviewUrl: audioPreview.value,
                    label: "Áudio (Opcional)"
                  }, null, 8, ["modelValue", "initialPreviewUrl"])
                ])
              ])
            ]),
            _createVNode(_unref(DialogFooter), null, {
              default: _withCtx(() => [
                _createVNode(_unref(Button), {
                  variant: "ghost",
                  onClick: _cache[17] || (_cache[17] = ($event: any) => (isDialogOpen.value = false))
                }, {
                  default: _withCtx(() => _cache[40] || (_cache[40] = [
                    _createTextVNode("Cancelar")
                  ])),
                  _: 1
                }),
                _createVNode(_unref(Button), {
                  onClick: save,
                  disabled: isSaving.value
                }, {
                  default: _withCtx(() => [
                    (isSaving.value)
                      ? (_openBlock(), _createBlock(_unref(Loader2), {
                          key: 0,
                          class: "mr-2 h-4 w-4 animate-spin"
                        }))
                      : _createCommentVNode("", true),
                    _cache[41] || (_cache[41] = _createTextVNode(" Salvar "))
                  ]),
                  _: 1
                }, 8, ["disabled"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["open"]),
    _createVNode(DeleteConfirmationDialog, {
      open: isDeleteDialogOpen.value,
      "onUpdate:open": _cache[19] || (_cache[19] = ($event: any) => ((isDeleteDialogOpen).value = $event)),
      loading: isDeleting.value,
      onConfirm: confirmDeleteAction
    }, null, 8, ["open", "loading"])
  ]))
}
}

})